import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { ButtonVariant } from "@/constants/button/button"
import { AppDispatch } from "@/redux"
import { useDispatch } from "react-redux"
import { FilterDataTable } from "@/components/custom/AlertDialogButton/CM/DataTable"
import { columns } from "@/components/custom/AlertDialogButton/CM/columns"
import { useState } from "react"
import { workflowActions } from '@/redux/slice/workflowSlice'
import { FilterProps } from "@/types/workflow"
import { SelectOption } from "@/types/inputField"
import { FilterCode } from "@/constants/filters/filters"

export const CheckboxFilter: React.FC<FilterProps> = ({
  code,
  stepId,
  order,
  selectedValue,
  selectOptions,
  name,
  description
}: FilterProps) => {
  const dispatch: AppDispatch = useDispatch()
  const [filterValues, setFilterValues] = useState<string[]>(selectedValue?.split(', ') ?? [])

  const selectAllFilters = () => {
    if (selectOptions) {
      const allFilters = selectOptions?.map(f => String((f as SelectOption)?.id))
      setFilterValues(allFilters)
    }
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          className="w-auto font-semibold"
          variant={ButtonVariant.DEFAULT}
        >
          Update
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="max-w-2xl">
        <AlertDialogHeader>
          <AlertDialogTitle className="mb-6">
            <div className="flex flex-row items-start justify-between">
              <div className="flex flex-col items-start">
                <h4 className="text-primary font-semibold text-xl leading-5 mb-2">
                  Filter Setup: {name}
                </h4>
                <p className="text-secondary text-sm mb-2 text-left font-normal">{description}</p>
              </div>
              <div className="flex items-center">
                <AlertDialogCancel className="mx-4">Cancel</AlertDialogCancel>
                <AlertDialogAction
                  type="submit"
                  disabled={filterValues.length === 0}
                  onClick={() => {
                    if (filterValues.length) {
                      dispatch(workflowActions.setStepFilter({
                        stepId,
                        order,
                        filter: code,
                        filterValue: filterValues.join(', '),
                      }))
                      dispatch(workflowActions.setLastUpdatedFilter(code as FilterCode))
                    }
                  }}
                >
                  Update Filter
                </AlertDialogAction>
              </div>
            </div>
          </AlertDialogTitle>
          {selectOptions?.length && (
            <div className="">
              <div className="my-8" />
              <div className="flex flex-row pt-3 pb-6">
                <Button
                  variant='secondary'
                  className="mr-4"
                  onClick={() => { selectAllFilters() }}
                >
                  Select All
                </Button>
                <Button
                  variant='secondary'
                  onClick={() => setFilterValues([])}
                >
                  Deselect All
                </Button>
              </div>
              <FilterDataTable
                columns={columns}
                data={selectOptions}
                selectedFilters={filterValues}
                onChange={(value: string) => {
                  if (filterValues.includes(value)) {
                    const updatedFilterValues = filterValues.filter(fv => fv !== value)
                    setFilterValues(updatedFilterValues)
                  } else {
                    const selectedFilters = [...filterValues, value]
                    setFilterValues(selectedFilters)
                  }
                }}
              />
            </div>
          )}
        </AlertDialogHeader>
      </AlertDialogContent>
    </AlertDialog>
  )
}
